module.exports = __webpack_public_path__ + "static/scale-model-of-tuscaloosa---the-one-and-only-in-tuscaloosa-alabama-0341c4ebee087ecfd670535b4b858262.png";